const generateRange = (start: number, end: number) => {
  const quantity = end - start + 1;

  return [...Array(quantity)].map((_, index) => index + start);
};

export { generateRange };
